module.exports = __webpack_public_path__ + "static/media/luxanna-win.c97c1d11.png";